import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, catchError, map, publishReplay, refCount, tap } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';
import { NotificationService } from 'src/app/services/notification.service';
import { BaseService } from 'src/app/services/providers/base.service';
import { UserActivityService } from 'src/app/services/userActivity.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { IBaseResponse } from '../../models/baseResponse.interface';
import { IAuthenticateResponse } from '../../models/user/authenticateResponse.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthentificationProviderService extends BaseService {

  constructor(
    private http: HttpClient,
    protected loaderService: LoaderService,
    protected userActivityService: UserActivityService,
    protected notificationService: NotificationService,
    protected storage: StorageService
  ) {
    super(loaderService, userActivityService, notificationService, storage);
  }

  login(username: string, password: string): Observable<{resp: IAuthenticateResponse; err: string}> {
    const params = new HttpParams();
    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/authenticate`, { username, password })
      .pipe(
        switchMap((response) => {
          if (response?.isSuccess) {
            return of({resp: response.data, err: null});
          } else {
            return of({resp: null, err: response.failureReason});
          }
        }),
        catchError(error => of(null)));
  }

  logout(refreshToken: string): Observable<void> {
    const params = new HttpParams();
    const httpOptions = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers: new HttpHeaders({ refreshToken }),
    };
    return this.http.get<void>(`${this.tcketManagerBaseUrl}account/logOut`, httpOptions)
      .pipe(
        catchError(error => of(null)));
  }


  checkConfirmToken(token: string): Observable<any> {
    const params = new HttpParams();
    const dACheckRegistrationTokenRequest = {
      token
    };
    const body = JSON.stringify(dACheckRegistrationTokenRequest);

    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/checkRegistrationToken`, body, { headers: this.httpHeaders, params })
      .pipe(
        map((response) => response?.isSuccess ? response.data.affiliateRole : null),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return of(false);
        }),
      );
  }

  refreshToken(refreshToken: string): Observable<IAuthenticateResponse> {
    const httpHeadersWithRefreshToken = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
      refreshToken
    });
    return this.http.post<IBaseResponse>(`${this.tcketManagerBaseUrl}account/refresh-token`, {},
      { headers: httpHeadersWithRefreshToken }).pipe(map((response: IBaseResponse) => response?.data),
        publishReplay(1),
        refCount(),
        catchError((err) => {
          console.log(err);
          return of(null);
        }),
      );
  }
}
